import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from '@roo/roo';

const Root = styled.div`
  padding-bottom: 80px;
  width: 1200px;
  margin: auto;
  &.news-list {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    .news-card {
      margin-bottom: 20px;
      width: 100%;
    }
  }
  &.article {
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const Trend = () => {
  const p = new URLSearchParams(window.location.search);
  const [h, setH] = React.useState(0);
  useEffect(function () {
    /**
     * @param e{MessageEvent}
     */
    function handle(e) {
      setH(Number(e.data));
    }
    window.addEventListener('message', handle);
    return () => {
      window.removeEventListener('message', handle);
    };
  }, []);

  return (
    <Root className={'article'}>
      <iframe
        src={decodeURIComponent(p.get('pageLink'))}
        frameBorder='0'
        style={{ height: h, marginTop: 40, backgroundColor: '#f4f4f4', width: '100%' }}
      />
      <div style={{ marginTop: 40 }}>
        <Link to={'/trend'}>
          <Button>返回基金动态</Button>
        </Link>
      </div>
    </Root>
  );
};

export default Trend;
